module.exports = __webpack_public_path__ + "static/media/neko-old-bg.eef8b8ea.mp4";